import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import CommonMessages from '~/core/commonMessages';
import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { AwayAndHomeTeam, LandingGame, LastTenRecord } from '../../types';
import TeamRecord from '../lastTenGames/components/TeamRecord/TeamRecord';

import { Last10GamesContainer } from './styles';

type LastTenGamesProps = {
    game: LandingGame;
    lastTen?: AwayAndHomeTeam<LastTenRecord>;
};

const LastTenGames: FC<LastTenGamesProps> = ({ game, lastTen }) => {
    const awayTeam: LastTenRecord | undefined = lastTen?.awayTeam;
    const homeTeam: LastTenRecord | undefined = lastTen?.homeTeam;

    if (!awayTeam?.record || !awayTeam.streak || !homeTeam?.record || !homeTeam.streak) {
        return null;
    }

    return (
        <Last10GamesContainer>
            <div role="heading" aria-level={2}>
                <FormattedMessage {...CommonMessages.tableHeaders.long.lastXGames} values={{ value: 10 }} />
            </div>
            {awayTeam && (
                <TeamRecord
                    teamName={parseValueFromLocalizedAttribute(game.awayTeam.commonName)}
                    teamRecord={awayTeam.record}
                    results={awayTeam.pastGameResults}
                />
            )}
            {homeTeam && (
                <TeamRecord
                    teamName={parseValueFromLocalizedAttribute(game.homeTeam.commonName)}
                    teamRecord={homeTeam.record}
                    results={homeTeam.pastGameResults}
                />
            )}
        </Last10GamesContainer>
    );
};

export default LastTenGames;
